import { pendingSelector } from 'api/selectors'
import { Image } from 'wordpress/components'
import { subscribeNews } from 'wordpress/actions'
import { componentSelector, subscriptionSelector } from 'wordpress/selectors'
import Checkbox from '@components/Checkbox'
import Button from '@components/Button'
import Textfield from '@components/Textfield'

import '../styles/Subscribe.scss'

class Subscribe extends Component {
    constructor(props) {
        super(props)

        this.submit = this.submit.bind(this)
        this.updateEmailInput = this.updateEmailInput.bind(this)

        this.state = {
            email: '',
        }
    }

    updateEmailInput(event) {
        const { value } = event.target
        this.setState({
            email: value,
        })
    }

    submit(event) {
        event.preventDefault()

        const { email } = this.state
        const { subscribeNews } = this.props

        subscribeNews(email)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.subscribed === false && nextProps.subscribed === true)
            this.setState({
                email: '',
            })
    }

    renderForm() {
        const { subscribed, subscribeMessage, pending, translate, defaults, consentLabel, requireConsent } = this.props
        const { email } = this.state
        const isLoading = pending === true
        const isSubscribed = subscribed === true
        const isConsentRequired = requireConsent || (requireConsent === undefined && defaults.requireConsent)

        return (
            <>
                <form onSubmit={this.submit}>
                    <fieldset disabled={isLoading}>
                        <div className="row no-gutters justify-content-center mt-3">
                            <div className="col-sm-6 col-10">
                                <Textfield
                                    value={email}
                                    onChange={this.updateEmailInput}
                                    name="email"
                                    type="email"
                                    required
                                    label={translate('input.placeholder.email')}
                                />
                            </div>
                            <div className="col-sm-auto col-10 mt-1 mt-sm-0 ml-sm-1">
                                <Button isLoading={isLoading} disabled={isLoading} block size="large">
                                    <T>sign.up.news.btn.label</T>
                                </Button>
                            </div>
                            {isConsentRequired && (
                                <div className="col-xl-9 col-lg-10 col-md-10 col-sm-9 col-10 mt-4">
                                    <Checkbox
                                        className="subscribe__checkbox"
                                        label={consentLabel || defaults.consentLabel}
                                        required
                                    />
                                </div>
                            )}
                        </div>
                    </fieldset>

                    {isSubscribed && (
                        <div className="subscribe__message text-center">
                            <strong>
                                <T>{subscribeMessage}</T>
                            </strong>
                        </div>
                    )}
                </form>
            </>
        )
    }

    renderTitle() {
        const { title, defaults } = this.props

        return <h2 className="text-center subscribe__heading">{title || defaults.title}</h2>
    }

    renderWithBackground() {
        const { backgroundImage } = this.props.defaults
        return (
            <Image
                className="subscribe__image d-flex align-items-center justify-content-center"
                image={backgroundImage}
                background>
                <div className="row no-gutters justify-content-center w-100">
                    <div className="col-12">{this.renderTitle()}</div>
                    <div className="col-lg-4 col-md-5 col-sm-7 mt-4">{this.renderForm()}</div>
                </div>
            </Image>
        )
    }

    render() {
        const { layout } = this.props

        return (
            <div className={`subscribe${layout ? ' text-block' : ' subscribe--with-background'}`}>
                {layout ? (
                    <>
                        {this.renderTitle()}
                        {this.renderForm()}
                    </>
                ) : (
                    this.renderWithBackground()
                )}
            </div>
        )
    }
}

const pendingSubscriptionSelector = createSelector(pendingSelector, pendings => pendings['newsletterSubscription'])

const mapStateToProps = createSelector(
    componentSelector('newsletters'),
    subscriptionSelector,
    pendingSubscriptionSelector,
    (config, subscription, pending) => ({
        defaults: config,
        ...subscription,
        pending,
    })
)

export default compose(withTranslate, connect(mapStateToProps, { subscribeNews }))(Subscribe)
